import {
  ShopperAgentOutreachOrigin,
  type ShopperAgentOutreachOrigin as ShopperAgentOutreachOriginType,
} from "./outreach-origin";

export const ShopperAgentAutomationKind = {
  Recover: "recover",
  Sms: "sms",
} as const;

export type ShopperAgentAutomationKind =
  (typeof ShopperAgentAutomationKind)[keyof typeof ShopperAgentAutomationKind];

/** Only when origin is automation; recover config implies Recover, else SMS automation. */
export function classifyShopperAgentAutomationKind(input: {
  readonly origin: ShopperAgentOutreachOriginType;
  readonly recoverConfigId?: string | null;
}): ShopperAgentAutomationKind | null {
  if (input.origin !== ShopperAgentOutreachOrigin.Automation) {
    return null;
  }
  if (input.recoverConfigId) {
    return ShopperAgentAutomationKind.Recover;
  }
  return ShopperAgentAutomationKind.Sms;
}
